import type { CapabilityObj } from 'homey-api';

import { Glyph } from '../common/Glyph';
import { HomeyIcon } from '../common/HomeyIcon';

import styles from './DeviceQuickAction.module.css';

interface DeviceQuickActionIconProps {
  iconObj: CapabilityObj['iconObj'] | null | undefined;
  source: string | null | undefined;
  useIconObj: boolean;
}

export function DeviceQuickActionIcon(props: DeviceQuickActionIconProps) {
  if (props.useIconObj === true && props.iconObj != null) {
    return (
      <HomeyIcon
        className={styles.glyphIcon}
        color="currentColor"
        iconObj={props.iconObj}
        size="20px"
      />
    );
  }

  if (props.source == null) {
    return null;
  }

  return <Glyph aria-hidden={true} className={styles.glyphIcon} source={props.source} />;
}
